/* SORAto — shared front-end behaviour */
(function () {
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function () {
    // Mobile menu (header section)
    var toggle = document.getElementById('menuToggle');
    var links = document.getElementById('navLinks');
    if (toggle && links) {
      toggle.addEventListener('click', function(){ links.classList.toggle('open'); });
      links.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ links.classList.remove('open'); }); });
    }
    // Scroll reveal
    var els = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.1 });
      els.forEach(function(el,i){ el.style.transitionDelay = (i%5*0.05)+'s'; io.observe(el); });
    } else {
      els.forEach(function(el){ el.classList.add('in'); });
    }
  });
})();
